import {
    get_aziende,
    get_azienda,
    create_azienda,
    update_azienda,
    attiva_azienda,
    disattiva_azienda,
} from "@/api/api.tenant.js";

const aziende = {
    namespaced: true,

    state: {
        lista: [],
        corrente: null,
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
        SET_CORRENTE: (state, azienda) => { state.corrente = azienda; },
    },

    actions: {
        carica({ commit }) {
            return new Promise((resolve, reject) => {
                get_aziende().then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        caricaDettaglio({ commit }, id) {
            return new Promise((resolve, reject) => {
                get_azienda(id).then(resp => {
                    commit("SET_CORRENTE", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati }) {
            const call = id ? update_azienda(id, dati) : create_azienda(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        attiva({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                attiva_azienda(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        disattiva({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                disattiva_azienda(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
        corrente: state => state.corrente,
    },
};

export default aziende;